import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getDisabledCadresRequest: ['response'],
    getDisabledCadresSuccess: ['response', 'loading'],
    getDisabledCadresFailure: ['error'],
})

export const getDisabledCadresTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getDisabledCadresSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getDisabledCadresFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getDisabledCadresRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_DISABLED_CADRES_REQUEST]: getDisabledCadresRequest,
    [Types.GET_DISABLED_CADRES_SUCCESS]: getDisabledCadresSuccess,
    [Types.GET_DISABLED_CADRES_FAILURE]: getDisabledCadresFailure,
})
